import { ApiServiceProvider } from './contexts/ApiServiceContext';
import { SWStateProvider } from './contexts/SWStateContext';
import { AppContent } from './components/AppContent';

/**
 * Main App component
 *
 * Responsibilities:
 * - Provide global context providers (SWState, ApiService)
 * - Delegate app content rendering to AppContent component
 *
 * This component is kept minimal to maintain a clean provider tree structure.
 * All initialization logic has been extracted to:
 * - src/startup/initializeSW.ts (module-level)
 * - src/startup/initializeAppInsights.ts (module-level)
 * - src/hooks/useAppInitialization.ts (app orchestration)
 * - src/hooks/useGlobalErrorHandlers.ts (error handling setup)
 */
export const App = () => {
  return (
    <SWStateProvider>
      <AppWithProviders />
    </SWStateProvider>
  );
};

const AppWithProviders = () => {
  return (
    <ApiServiceProvider>
      <AppContent />
    </ApiServiceProvider>
  );
};
